<template>
  <div>
    <field-validation :label="rotulo" :field="nome" :status="errors" :custom-errors="apiErrors" :show-icon="false"
      v-if="telaEhMobile">
      <input type="date" class="form-control sem-espaco-dir" :name="nome" :id="nome" :data-vv-as="rotulo"
        :v-validate="validacao" :max="dataMaxima" :min="dataMinima" :value="valorDaData"
        @input="valorDoInput($event.target.value)" :disabled="disabled">
    </field-validation>
    <field-validation :label="rotulo" :field="nome" :status="errors" :custom-errors="apiErrors" :show-icon="false"
      v-else>
      <date-picker 
        :name="nome" 
        :id="nome" 
        :config="config" 
        :data-vv-as="rotulo" 
        :value="valorDaData"
        v-validate="validacao" 
        @input="valorDoInput($event)" 
        :class="{ 'disabled': disabled }" />
    </field-validation>
  </div>
</template>

<script>
import moment from 'moment'
import DateHelper from '@/helpers/DateHelper'

export default {
  data() {
    return {
      config: {
        format: 'L',
        useCurrent: false,
        locale: 'pt-br',
        maxDate: this.dataMaxima,
        minDate: this.dataMinima,
        ignoreReadonly: false
      },
      apiErrors: null
    }
  },
  props: {
    value: {
      type: String,
      default: moment(new Date()).format('YYYY-MM-DD'),
      required: false
    },
    rotulo: {
      type: String,
      required: true
    },
    nome: {
      type: String,
      required: true
    },
    valor: {
      type: String,
      default: moment(new Date()).format('YYYY-MM-DD'),
      required: false
    },
    dataMaxima: {
      type: String,
      default: moment(new Date()).format('YYYY-MM-DD'),
      required: false
    },
    dataMinima: {
      type: String,
      default: moment(new Date()).add(-100, 'years').format('YYYY-MM-DD'),
      required: false
    },
    validacao: {
      type: Object,
      default: {},
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    telaEhMobile() {
      return window.innerWidth <= 768
    },
    valorDaData() {
      let data = null
      if (this.value) {
        if (this.telaEhMobile) {
          data = this.value
          return data
        }
        data = DateHelper.convertDateToPtbr(this.value)
        return data
      }
      return data
    }
  },
  methods: {
    valorDoInput(event) {
      if (!this.disabled) {
        this.$emit('input', event)
      }
    }
  },
  watch: {
    disabled: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            const input = this.$el.querySelector('input')
            if (input) {
              input.setAttribute('readonly', 'readonly')
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.sem-espaco-dir {
  padding-right: 0;
}

input:disabled,
.disabled {
  background-color: #eeee !important;
  opacity: 1 !important;
  cursor: not-allowed !important;
}

.disabled input {
  background-color: #eeee !important;
  opacity: 1 !important;
  cursor: not-allowed !important;
}
</style>


// WEBPACK FOOTER //
// index.vue?606947a2